import { emailApiClient } from './emailApiClient';
import { QueuesResponse } from '../models/Queue';

export const fetchQueues = async (originalQueueId?: string): Promise<QueuesResponse> => {
  if (!originalQueueId) {
    throw new Error('originalQueueId is required to fetch queues');
  }

  const path = `/transfer-queues?originalQueueId=${encodeURIComponent(originalQueueId)}`;

  const response = await emailApiClient(path, { method: 'GET' });

  if (!response.ok) {
    throw new Error(`Failed to fetch queues: ${response.status} ${response.statusText}`);
  }

  return response.json() as Promise<QueuesResponse>;
};
